export { default as isSharePointLink, isSPMySiteLink } from './isSharePointLink';
